import React from 'react';
import { Link } from 'gatsby';
import { BoxArrowDownRight } from 'react-bootstrap-icons';

import { ApiContext } from '../../context/apicontext';
import { SessionContext } from '../../context/sessioncontext';
import { getInteract } from '../../utils/common';

export const CommentsLink = (props) => {
	const Api = React.useContext(ApiContext);
	const userSession = React.useContext(SessionContext);
	const { post } = props;

	const [loggedIn, setLoggedIn] = React.useState(!!userSession.user);
	const [counts, setCounts] = React.useState(undefined);

	React.useEffect(() => {
		setLoggedIn(!!userSession.user);
	}, [userSession, setLoggedIn]);

	React.useEffect(() => {
		const fetchTally = () => {
			const apiurl = `discussion/${discussionId}`;
			const apioptions = {};
			if (userSession.user) {
				apioptions.headers = {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${userSession.session}`
				};
			}
			Api.fetch(`${apiurl}`, apioptions, (result) => {
				if (!active) return;
				if (result.response === 1) {
					setCounts(prev => {
						return {
							total: Math.max(result.discussion.total_count, prev ? prev.total : 0),
							read: Math.max(result.discussion.read_count ?? 0, prev ? prev.read : 0)
						};
					});
				}
			});
		};
		let active = true;
		const discussionId = getInteract(post.frontmatter, 'discussion');
		if (!discussionId) return;
		if (counts && !loggedIn)
			setCounts({...counts, read: 0});
		else
			fetchTally();
		return () => { active = false };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn]);

	if (!counts) return (<></>);

	const unread = counts.total - counts.read;

	return (
		<span style={{ fontSize: '.9rem' }}>
			<Link to={`${post.fields.slug}#comments`} className={counts.total > 0 && unread === counts.total ? 'strong' : ''}>
				{counts.total} Comment{counts.total !== 1 ? 's' : ''}
			</Link>
			{unread > 0 && unread !== counts.total &&
				<span style={{ marginLeft: '.5em' }}>
					(
						<Link to={`${post.fields.slug}#a,${counts.read+1}`} className='strong'>
							{unread} New!
						</Link>
					)
				</span>
			}
			{counts.total > 0 &&
				<span style={{ marginLeft: '.5em' }}>
					<Link to={`${post.fields.slug}#a,${counts.total}`} title='View newest comment'>
						<BoxArrowDownRight size='12' />
					</Link>
				</span>
			}
		</span>
	);
};
